import { InjectionToken, Provider } from '@angular/core';
import { Action, ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CATALOG, CATALOG_ROOT_NODE_ID, CatalogData, CatalogState } from '../catalog-state';
import { reducer as catalogRootNodeIdReducer } from './catalog-root-node-id.reducer';
import { reducer as catalogReducer } from './catalog.reducer';

export function getReducers(): ActionReducerMap<CatalogState> {
  return {
    catalog: StateUtils.loaderReducer<CatalogData>(
      CATALOG,
      catalogReducer as (state: CatalogData, action: Action<string>) => CatalogData,
    ),
    rootNodeId: StateUtils.loaderReducer<string>(
      CATALOG_ROOT_NODE_ID,
      catalogRootNodeIdReducer as (state: string, action: Action<string>) => string,
    ),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CatalogState>> = new InjectionToken<
  ActionReducerMap<CatalogState>
>('CatalogReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
